(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["discount-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('discount-price')) {
    customElements.define(
      'discount-price',
      class DiscountPrice extends HTMLElement {
        connectedCallback() {
          this.prices = JSON.parse(this.querySelector('[data-variant-prices]').textContent);
          this.salePrice = this.querySelector('[data-discounted-price]');
          this.originalPrice = this.querySelector('[data-original-price]');
          this.scope = this.closest('product-info') || this.closest('section') || document;
          this.handleVariantChange = this.handleVariantChange.bind(this);
          this.scope.addEventListener('change', this.handleVariantChange);
          this.scope.addEventListener('variant:change', this.handleVariantChange);
          this.scope.addEventListener('variant:changed', this.handleVariantChange);
          this.scope.addEventListener('product:variant-change', this.handleVariantChange);
        }

        disconnectedCallback() {
          this.scope.removeEventListener('change', this.handleVariantChange);
          this.scope.removeEventListener('variant:change', this.handleVariantChange);
          this.scope.removeEventListener('variant:changed', this.handleVariantChange);
          this.scope.removeEventListener('product:variant-change', this.handleVariantChange);
        }

        handleVariantChange(event) {
          const variant = event.detail?.variant || event.detail?.selectedVariant;

          if (variant?.id && this.prices[String(variant.id)]) {
            this.render(variant.id);
            return;
          }

          requestAnimationFrame(() => {
            requestAnimationFrame(() => this.syncFromProductForm());
          });
        }

        syncFromProductForm() {
          const productFormId = this.scope.getAttribute('form');
          const productForm = productFormId
            ? document.getElementById(productFormId)
            : this.scope.querySelector('form[action*="/cart/add"]');
          const variantInput = productForm?.querySelector('[name="id"]');

          if (variantInput?.value) this.render(variantInput.value);
        }

        render(variantId) {
          const price = this.prices[String(variantId)];

          if (!price) return;

          this.salePrice.textContent = price.discounted;
          this.originalPrice.textContent = price.original;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
